export default "__VITE_ASSET__KTHzQtK8__"